import { render, staticRenderFns } from "./FavouriteService.vue?vue&type=template&id=7bea9ffc"
import script from "./FavouriteService.vue?vue&type=script&lang=js"
export * from "./FavouriteService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bea9ffc')) {
      api.createRecord('7bea9ffc', component.options)
    } else {
      api.reload('7bea9ffc', component.options)
    }
    module.hot.accept("./FavouriteService.vue?vue&type=template&id=7bea9ffc", function () {
      api.rerender('7bea9ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FavouriteService.vue"
export default component.exports